'use client';

import { useState } from 'react';
import PharmaLoginModal from './PharmaLoginModal';
import ExplorePharmaModal from './ExplorePharmaModal';

export default function ExplorePharmaButton() {
  const [showLogin, setShowLogin] = useState(false);
  const [showDashboard, setShowDashboard] = useState(false);

  function handleLoginSuccess() {
    setShowLogin(false);
    setShowDashboard(true);
  }

  return (
    <>
      <button
        onClick={() => setShowLogin(true)}
        className="w-full max-w-sm sm:w-auto mx-auto sm:mx-0 font-bold text-base sm:text-lg px-6 sm:px-10 py-3.5 sm:py-4 rounded-lg transition-all duration-300 hover:scale-105"
        style={{
          background: 'transparent',
          border: '1.5px solid #C5A572',
          color: '#F8F6F3',
        }}
        onMouseEnter={(e) => {
          (e.currentTarget as HTMLElement).style.background = 'rgba(197,165,114,0.12)';
          (e.currentTarget as HTMLElement).style.color = '#C5A572';
        }}
        onMouseLeave={(e) => {
          (e.currentTarget as HTMLElement).style.background = 'transparent';
          (e.currentTarget as HTMLElement).style.color = '#F8F6F3';
        }}
      >
        Explore Pharma
      </button>

      <PharmaLoginModal
        isOpen={showLogin}
        onClose={() => setShowLogin(false)}
        onSuccess={handleLoginSuccess}
      />

      <ExplorePharmaModal
        isOpen={showDashboard}
        onClose={() => setShowDashboard(false)}
      />
    </>
  );
}
